// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../pages/HomePageEmissor/components/assets/migration-tour-pointer.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ktym0H {
  position: fixed;
  inset: 0;
  pointer-events: none;
}

.Wk_vu9 {
  position: fixed;
  inset: 0;
  display: block;
  pointer-events: auto;
}

.i1TOyB {
  position: fixed;
  inset: 0;
  pointer-events: auto;
  background: rgba(15, 15, 15, 0.55);
}

.y5116B {
  position: fixed;
  pointer-events: auto;
  width: min(var(--benefits-onboarding-panel-max-px, 297px), calc(100vw - 32px));
  max-height: min(50vh, 360px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-2);
  padding: var(--spacing-1-5) var(--spacing-2) var(--spacing-2);
  box-sizing: border-box;
  background: var(--background-white);
  border-radius: var(--radius-s);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  z-index: 99991;
  overflow: visible;
  isolation: isolate;
}

.lqur_T,
.OWtxSO {
  position: absolute;
  left: 0;
  width: 0;
  height: 0;
  margin-left: -10px;
  pointer-events: none;
  z-index: 2;
}

.lqur_T {
  top: -10px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--background-white);
  filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.06));
}

.OWtxSO {
  bottom: -10px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid var(--background-white);
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06));
}

.FyAgrY {
  position: absolute;
  right: -10px;
  top: 50%;
  margin-top: -10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid var(--background-white);
  filter: drop-shadow(1px 0 1px rgba(0, 0, 0, 0.06));
  pointer-events: none;
  z-index: 2;
}

.b0PhZ1 {
  position: absolute;
  left: -10px;
  top: 50%;
  margin-top: -10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid var(--background-white);
  filter: drop-shadow(-1px 0 1px rgba(0, 0, 0, 0.06));
  pointer-events: none;
  z-index: 2;
}

.oGPPGa {
  position: relative;
  width: 100%;
  padding: 0;
  padding-right: var(--spacing-4);
  box-sizing: border-box;
}

._srOVh {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: var(--spacing-3);
  height: var(--spacing-3);
  padding: 0;
  border: none;
  background: transparent;
  border-radius: var(--radius-s);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-neutral-stronger);
}

.LMtWEp {
  width: var(--spacing-1-5);
  height: var(--spacing-1-5);
  display: block;
  flex: none;
}

._srOVh:hover {
  background: var(--surface-neutral-subtle);
}

.CvxqIm {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-auto);
  color: var(--text-neutral-dark);
  margin: 0;
  min-width: 0;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.H9dBtv {
  width: 100%;
  padding: 0;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
}

.IIveRQ {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--type-label-sm-regular-line-height);
  color: var(--text-neutral-stronger);
  margin: 0;
}

.wExf27 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--spacing-2);
  width: 100%;
  padding: 0;
  margin-top: auto;
  box-sizing: border-box;
}

.RuMot_ {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--type-label-sm-regular-line-height);
  color: var(--text-neutral-stronger);
}

.AVGM8u {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-2);
  margin-left: auto;
}

@media (max-width: 480px) {
  .y5116B {
    max-height: min(70vh, 480px);
  }

  .wExf27 {
    flex-direction: column;
    align-items: stretch;
  }

  .AVGM8u {
    margin-left: 0;
    flex-direction: column;
  }
}

.jMFpaK .y5116B {
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.jMFpaK .CvxqIm {
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0;
}

.jMFpaK .oGPPGa {
  min-height: 24px;
  display: flex;
  align-items: flex-start;
}

.jMFpaK .IIveRQ,
.jMFpaK .RuMot_ {
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.jMFpaK .wExf27 {
  margin-top: 8px;
  gap: 16px;
}

.jMFpaK .AVGM8u {
  gap: 12px;
}

.jMFpaK .AVGM8u button {
  height: 24px;
  min-height: 24px;
  padding: 2px 8px;
  border-width: 1px;
  --size: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  gap: 4px;
  border-radius: 4px;
}

.jMFpaK .AVGM8u button:first-child {
  width: 63px;
  min-width: 63px;
}

.jMFpaK .AVGM8u .ll27IB {
  width: 73px;
  min-width: 73px;
}

.jMFpaK .AVGM8u .bUKFhV {
  width: 76px;
  min-width: 76px;
}

.jMFpaK .qkzOqP {
  flex: none;
}

.jMFpaK button:disabled .qkzOqP {
  filter: grayscale(1);
  opacity: 0.4;
}

.jMFpaK .lqur_T,
.jMFpaK .OWtxSO,
.jMFpaK .FyAgrY,
.jMFpaK .b0PhZ1 {
  width: 15px;
  height: 8px;
  border: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
  filter: none;
}

.jMFpaK .lqur_T {
  top: -5px;
  margin-left: -7.5px;
  transform: rotate(180deg);
}

.jMFpaK .OWtxSO {
  bottom: -5px;
  margin-left: -7.5px;
}

.jMFpaK .FyAgrY {
  right: -8.5px;
  margin-top: -4px;
  transform: rotate(-90deg);
}

.jMFpaK .b0PhZ1 {
  left: -8.5px;
  margin-top: -4px;
  transform: rotate(90deg);
}

.jMFpaK .i1TOyB {
  background: rgba(31, 31, 31, 0.6);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BenefitsOnboardingWizard/BenefitsOnboardingSpotlight.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,8EAA8E;EAC9E,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,6DAA6D;EAC7D,sBAAsB;EACtB,mCAAmC;EACnC,8BAA8B;EAC9B,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,oCAAoC;EACpC,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,oCAAoC;EACpC,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,+CAA+C;EAC/C,kDAAkD;EAClD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,gDAAgD;EAChD,mDAAmD;EACnD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;EACvC,qDAAqD;EACrD,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;EACvC,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oEAA4G;EAC5G,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".root {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n}\n\n.spotlightDim {\n  position: fixed;\n  inset: 0;\n  display: block;\n  pointer-events: auto;\n}\n\n.fullDim {\n  position: fixed;\n  inset: 0;\n  pointer-events: auto;\n  background: rgba(15, 15, 15, 0.55);\n}\n\n.panel {\n  position: fixed;\n  pointer-events: auto;\n  width: min(var(--benefits-onboarding-panel-max-px, 297px), calc(100vw - 32px));\n  max-height: min(50vh, 360px);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n  padding: var(--spacing-1-5) var(--spacing-2) var(--spacing-2);\n  box-sizing: border-box;\n  background: var(--background-white);\n  border-radius: var(--radius-s);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);\n  z-index: 99991;\n  overflow: visible;\n  isolation: isolate;\n}\n\n.panelArrowUp,\n.panelArrowDown {\n  position: absolute;\n  left: 0;\n  width: 0;\n  height: 0;\n  margin-left: -10px;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.panelArrowUp {\n  top: -10px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid var(--background-white);\n  filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.06));\n}\n\n.panelArrowDown {\n  bottom: -10px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid var(--background-white);\n  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06));\n}\n\n.panelArrowRight {\n  position: absolute;\n  right: -10px;\n  top: 50%;\n  margin-top: -10px;\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 10px solid var(--background-white);\n  filter: drop-shadow(1px 0 1px rgba(0, 0, 0, 0.06));\n  pointer-events: none;\n  z-index: 2;\n}\n\n.panelArrowLeft {\n  position: absolute;\n  left: -10px;\n  top: 50%;\n  margin-top: -10px;\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid var(--background-white);\n  filter: drop-shadow(-1px 0 1px rgba(0, 0, 0, 0.06));\n  pointer-events: none;\n  z-index: 2;\n}\n\n.panelHeader {\n  position: relative;\n  width: 100%;\n  padding: 0;\n  padding-right: var(--spacing-4);\n  box-sizing: border-box;\n}\n\n.closePanel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-neutral-stronger);\n}\n\n.closePanelIcon {\n  width: var(--spacing-1-5);\n  height: var(--spacing-1-5);\n  display: block;\n  flex: none;\n}\n\n.closePanel:hover {\n  background: var(--surface-neutral-subtle);\n}\n\n.panelTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-style: normal;\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-auto);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  min-width: 0;\n  letter-spacing: -0.02em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.scrollBody {\n  width: 100%;\n  padding: 0;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.panelBody {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-style: normal;\n  font-weight: var(--font-weight-regular);\n  line-height: var(--type-label-sm-regular-line-height);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n}\n\n.panelFooter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--spacing-2);\n  width: 100%;\n  padding: 0;\n  margin-top: auto;\n  box-sizing: border-box;\n}\n\n.stepText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-style: normal;\n  font-weight: var(--font-weight-regular);\n  line-height: var(--type-label-sm-regular-line-height);\n  color: var(--text-neutral-stronger);\n}\n\n.buttonGroup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-2);\n  margin-left: auto;\n}\n\n@media (max-width: 480px) {\n  .panel {\n    max-height: min(70vh, 480px);\n  }\n\n  .panelFooter {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .buttonGroup {\n    margin-left: 0;\n    flex-direction: column;\n  }\n}\n\n.migration .panel {\n  gap: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n}\n\n.migration .panelTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0;\n}\n\n.migration .panelHeader {\n  min-height: 24px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.migration .panelBody,\n.migration .stepText {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.migration .panelFooter {\n  margin-top: 8px;\n  gap: 16px;\n}\n\n.migration .buttonGroup {\n  gap: 12px;\n}\n\n.migration .buttonGroup button {\n  height: 24px;\n  min-height: 24px;\n  padding: 2px 8px;\n  border-width: 1px;\n  --size: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: normal;\n  gap: 4px;\n  border-radius: 4px;\n}\n\n.migration .buttonGroup button:first-child {\n  width: 63px;\n  min-width: 63px;\n}\n\n.migration .buttonGroup .migrationForwardButton {\n  width: 73px;\n  min-width: 73px;\n}\n\n.migration .buttonGroup .migrationFinishButton {\n  width: 76px;\n  min-width: 76px;\n}\n\n.migration .migrationBackIcon {\n  flex: none;\n}\n\n.migration button:disabled .migrationBackIcon {\n  filter: grayscale(1);\n  opacity: 0.4;\n}\n\n.migration .panelArrowUp,\n.migration .panelArrowDown,\n.migration .panelArrowRight,\n.migration .panelArrowLeft {\n  width: 15px;\n  height: 8px;\n  border: none;\n  background: url('../../pages/HomePageEmissor/components/assets/migration-tour-pointer.svg') center no-repeat;\n  filter: none;\n}\n\n.migration .panelArrowUp {\n  top: -5px;\n  margin-left: -7.5px;\n  transform: rotate(180deg);\n}\n\n.migration .panelArrowDown {\n  bottom: -5px;\n  margin-left: -7.5px;\n}\n\n.migration .panelArrowRight {\n  right: -8.5px;\n  margin-top: -4px;\n  transform: rotate(-90deg);\n}\n\n.migration .panelArrowLeft {\n  left: -8.5px;\n  margin-top: -4px;\n  transform: rotate(90deg);\n}\n\n.migration .fullDim {\n  background: rgba(31, 31, 31, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Ktym0H`,
	"spotlightDim": `Wk_vu9`,
	"fullDim": `i1TOyB`,
	"panel": `y5116B`,
	"panelArrowUp": `lqur_T`,
	"panelArrowDown": `OWtxSO`,
	"panelArrowRight": `FyAgrY`,
	"panelArrowLeft": `b0PhZ1`,
	"panelHeader": `oGPPGa`,
	"closePanel": `_srOVh`,
	"closePanelIcon": `LMtWEp`,
	"panelTitle": `CvxqIm`,
	"scrollBody": `H9dBtv`,
	"panelBody": `IIveRQ`,
	"panelFooter": `wExf27`,
	"stepText": `RuMot_`,
	"buttonGroup": `AVGM8u`,
	"migration": `jMFpaK`,
	"migrationForwardButton": `ll27IB`,
	"migrationFinishButton": `bUKFhV`,
	"migrationBackIcon": `qkzOqP`
};
module.exports = ___CSS_LOADER_EXPORT___;
